import { render } from "./FileForm.vue?vue&type=template&id=d8e17d22&scoped=true"
import script from "./FileForm.vue?vue&type=script&lang=js"
export * from "./FileForm.vue?vue&type=script&lang=js"

import "./FileForm.vue?vue&type=style&index=0&id=d8e17d22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8e17d22"]])

export default __exports__